var ctrlopt = ctrlopt,
    generic = generic || {},
    FB = FB || '',
    site = site || {};
(function($) {
  var apptBook = Drupal.appointmentBooking;

  var settings = Drupal.settings || {};
  var oab = settings.globals_variables || {};
  var OAB_register_password_mandatory = oab.OAB_register_password_mandatory || 0;
  var hide_newsletter_checkbox = oab.hide_newsletter_checkbox || 0;
  var ommit_sms = oab.appointment_booking_ignore_sms || 0;
  var phone_code_multiple_prefix = oab.phone_code_multiple_prefix || 0;
  var appointment_booking_show_mobile_prefix = oab.appointment_booking_show_mobile_prefix || 0;
  /* Concrete View */
  apptBook.confirmAccount = function(container) {
    apptBook.confirmAccount.superclass.constructor.call(this);
    this.id = 'confirm';
    this.jqBod = $('body');
    this.container = container;
    this.signInContainer = container.find('.sign-in-container');
    this.bookContainer = container.find('.book-appt-container');
    this.confContainer = container.find('.booking-container');
    this.startOver = this.bookContainer.find('.start-over');
    this.selErrOverlay = container.find('.appt-book-services-overlay').remove();
    this.bookConflictOverlay = container.find('.appt-book-book-conflict-overlay').remove();
    this.calendarId = '0';
    this.appointmentId = null;
    this.serviceIds = [];
    this.updateMode = false;
  };

  ctrlopt.extend(apptBook.confirmAccount, apptBook.AbstractSection);

  apptBook.confirmAccount.prototype.onUpdate = function(data) {
    var servs, servObj,
        hasCounter = false,
        hasCounters = false,
        me = this,
        aPgName = document.title + ' - Confirm Account & Book';

    this.serviceIds = [];
    this.updateMode = false;

    function runUpdate() {
      if (hasCounter && hasCounters) {
        me.buildBookAppt();
      }
    }

    function processUpdate() {
      if (data.params.appointmentId) {
        me.model.getAppointment(data.params.appointmentId, function(apptData) {
          me.updateMode = true;
          me.counterId = data.params.counterId;
          me.calendarId = data.params.calendarId;
          me.serviceIds = data.params.serviceIds;
          me.appointmentId = apptData.id;
          me.startTime = data.params.startTime;

          me.model.getCounter(me.counterId, {service_id: me.serviceIds}, function(data) {
            me.counterData = data;
            hasCounter = true;
            runUpdate();
          });
        }, function() { // If there is an error retrieving appointment id, go to beginning of APP
          var myUrl = [location.protocol, '//', location.host, location.pathname].join('');
          window.location = myUrl;
        });
      } else {
        me.counterId = data.params.counterId;
        me.startTime = data.params.startTime;
        me.calendarId = data.params.calendarId;
        me.serviceIds = data.params.serviceIds;
        me.services = data.params.services;
        me.myNonSubsequentDuration = data.params.myNonSubsequentDuration;
        me.nonSubsequentServicesSelf = data.params.nonSubsequentServicesSelf;
        me.subsequentServicesSelf = data.params.subsequentServicesSelf;
        me.model.getCounter(me.counterId, {service_id: me.serviceIds}, function(data) {
          me.counterData = data;
          hasCounter = true;
          runUpdate();
        });
      }

      me.model.fetchCountersData({service_id: this.serviceIds}, function(data) {
        me.countersData = data;
        hasCounters = true;
        runUpdate();
      });
    }

    if (data.sectionId === this.id) {

      generic.jsonrpc.fetch({
        method: 'user.json',
        //params: [],
        onSuccess: function(jsonRpcResponse) {
          me.userData = jsonRpcResponse.getValue();
          processUpdate();
        },
        onFailure: function(jsonRpcResponse) {
          me.userData = null;
          processUpdate();
        }
      });
    }
  };

  apptBook.confirmAccount.prototype.buildBookAppt = function() {
    var totText,
        me = this,
        signIn = this.signInContainer.find('#appt-book-sign-in-form-container'),
        signInLinkContainer = this.signInContainer.find('.sign-in-link-container'),
        signInLink = this.signInContainer.find('#appt-book-sign-in-link').off('click'),
        guestLinkContainer = this.signInContainer.find('.guest-link-container'),
        guestLink = this.signInContainer.find('#appt-book-guest-link').off('click'),
        loginEmail = this.signInContainer.find('#appt-book-login-email'),
        pw = this.signInContainer.find('#appt-book-login-password'),
        forgotPasswordLink = this.signInContainer.find('.js-forgot-password').off('click'),
        hiddenForm = this.signInContainer.find('.js-signin-hidden-form'),
        signInBtn = signIn.find('#appt-book-login-submit').off('click'),
        fbsignInBtn = signIn.find('#appt-book-fblogin-submit').off('click'),
        bookBtn = this.confContainer.find('#appt-book-book-submit'), //.off('click'),
        guestLinkText = this.bookContainer.find('.guest-link-text'),
        fNameInput = this.bookContainer.find('.appt-book-first-name'),
        lNameInput = this.bookContainer.find('.appt-book-last-name'),
        lNameOptional = this.bookContainer.hasClass('no-last-name'),
        emailInput = this.bookContainer.find('.appt-book-email'),
        countryCode = this.bookContainer.data('countryCode') || '',
        phoneInput = this.bookContainer.find('.appt-book-mobile'),
        phoneInput1 = this.bookContainer.find('.appt_mobile_part1'),
        phoneInput2 = this.bookContainer.find('.appt_mobile_part2'),
        phonePrefixInput = this.bookContainer.find('.appt-book-mobile-prefix'),
        koreaLegal = this.bookContainer.data('krLegal'),
        isSMSNotificationsEnabled = this.bookContainer.data('enableSms'),
        smsNotificationTerms = this.bookContainer.find('input[name=APPT_SMS_NOTIFICATIONS]'),
        checkboxInput = this.container.find('input[type=checkbox]'),
        commentsInput = this.bookContainer.find('.appt-book-note'),
        rPassContainer = this.bookContainer.find('.register-password-container'),
        rpw = rPassContainer.find('#appt-book-register-password'),
        signUpEmailInput = this.bookContainer.find('.registration__email-list').find('input'),
        signUpSMSInput = this.bookContainer.find('.registration__sms-list').find('input'),
        signUpPrivacyInput = this.bookContainer.find('.registration__privacy-list').find('input'),
        signUpPrivacyContainer = this.bookContainer.find('.registration__privacy_policy-container'),
        signUpEmailContainer = this.bookContainer.find('.registration__email-container'),
        signUpTitleContainer = this.container.find('.book-appt-titles'),
        signUpTitleInput = signUpTitleContainer.find('input'),
        signUpSMSContainer = this.bookContainer.find('.registration__sms-container'),
        errorContainer = this.container.find('#appt-book-confirm-error-messages'),
        errorMessages = errorContainer.find('.error-message'),
        emailPromotionsLabel = this.bookContainer.find('.registration__email-list'),
        acceptedPrivacyPolicy = this.bookContainer.find('input[name="ACCEPTED_PRIVACY_POLICY"]'),
        oabSMSOptin = this.bookContainer.find('input[name="APPT_SMS_NOTIFICATIONS"]'),
        pcEmailPromotions = this.bookContainer.find('input[name="PC_EMAIL_PROMOTIONS"]'),
        smsPromotions = this.bookContainer.find('input[name="SMS_PROMOTIONS"]'),
        postalPromotions = this.bookContainer.find('input[name="POSTAL_PROMOTIONS"]'),
        acceptedThirdParty = this.bookContainer.find('input[name="ACCEPTED_THIRD_PARTY"]'),
        acceptTermsHead = this.bookContainer.find('.terms-head'),
        acceptoabSMSHead = this.bookContainer.find('.accept-sms-notification-head'),
        acceptPrivacyHead = this.bookContainer.find('.accept-privacy-head'),
        acceptEmailHead = this.bookContainer.find('.email-head'),
        acceptSMSHead = this.bookContainer.find('.sms-head'),
        acceptPostalHead = this.bookContainer.find('.postal-head'),
        acceptThirdPartyHead = this.bookContainer.find('.accept-thirdparty-head'),
        signInHeight,
        drupal = Drupal || {},
        settings = drupal.settings || {};

    if (settings.fb_login_app_id && site.facebook && typeof FB === 'object') {
      site.facebook.init();
      $('body').on('click', '.js-appt-fb-login-button', function() {
        FB.login(function(response) {
          if (response.status === 'connected') {
            fbsignInBtn.click();
          }
        });
      });
    }

    checkboxInput.picker();
    signUpTitleInput.picker();

    $(window).on('loadPreviousApptObjBackButton', function() {
      var upObj = {
        sectionId: 'appointments',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          calendarId: me.calendarId,
          serviceIds: me.serviceIds,
          services: me.services,
          appointmentId: me.appointmentId,
          startTime: me.startTime,
          initialized: false
        }
      };
      return upObj;
    });

    if (me.userData.signed_in) {
      guestLinkText.addClass('hidden');
    }
    if (me.userData.signed_in && hide_newsletter_checkbox) {
      signUpPrivacyContainer.addClass('hidden');
    }

    var passwordInput = this.bookContainer.find('.register__password');

    this.startOver.off('click');
    this.startOver.click(function() {
    });

    if (phone_code_multiple_prefix) {
      var apptPhoneCode = me.bookContainer.find('.js-phone-multiple-prefix');
      apptPhoneCode = apptPhoneCode.text();
      var apptMultiplePrefix = me.bookContainer.find('select.js-phone-multiple-prefix-select');
      var apptPhoneCodeSplit = apptPhoneCode.split(',');
      var codeOptions;
      $.each(apptPhoneCodeSplit, function(i, val) {
        codeOptions = $('<option></option>', {value: val, text: val});
        apptMultiplePrefix.append(codeOptions);
      });
    }

    fNameInput.placeholder();
    fNameInput.value = fNameInput.attr('placeholder');
    fNameInput.addClass('appt-placeholder');

    lNameInput.placeholder();
    lNameInput.value = lNameInput.attr('placeholder');
    lNameInput.addClass('appt-placeholder');

    emailInput.placeholder();
    emailInput.value = emailInput.attr('placeholder');
    emailInput.addClass('appt-placeholder');

    phoneInput.placeholder();
    phoneInput.value = phoneInput.attr('placeholder');
    phoneInput.addClass('appt-placeholder');

    passwordInput.placeholder();
    passwordInput.value = passwordInput.attr('placeholder');
    passwordInput.addClass('appt-placeholder');

    loginEmail.placeholder();
    loginEmail.value = loginEmail.attr('placeholder');
    loginEmail.addClass('appt-placeholder');

    pw.placeholder();
    pw.value = pw.attr('placeholder');
    pw.addClass('appt-placeholder');

    fNameInput.keyup(function(e) {
      var maxlength = fNameInput.attr('data-placeholder-maxlength');
      if (!!maxlength) {
        var text = fNameInput.val();
        if (text.length > maxlength) {
          fNameInput.val(text.substring(0, maxlength));
          e.preventDefault();
        }
      }
    });

    lNameInput.keyup(function(e) {
      var maxlength = lNameInput.attr('data-placeholder-maxlength');
      if (!!maxlength) {
        var text = lNameInput.val();
        if (text.length > maxlength) {
          lNameInput.val(text.substring(0, maxlength));
          e.preventDefault();
        }
      }
    });

    phoneInput.keydown(function(e) {
      var key = e.charCode || e.keyCode || 0;

      // Allow numeric (and tab, backspace, delete) keys only
      return key == 8 ||
          key == 9 ||
          key == 46 ||
          (key >= 48 && key <= 57) ||
          (key >= 96 && key <= 105);
    });

    phoneInput.keyup(function(e) {
      var $this = $(this);
      var maxlength = $this.attr('data-placeholder-maxlength');
      if (!!maxlength) {
        var text = $this.val();
        if (text.length > maxlength) {
          $this.val(text.substring(0, maxlength));
          e.preventDefault();
        }
      }
    });

    loginEmail.val('');
    pw.val('');
    rpw.val('');
    emailInput.val('').removeAttr('disabled');

    if (this.userData && this.userData.signed_in) {
      this.signInContainer.css('display', 'none');
      // signUpPrivacyContainer.css('display', 'none');

      rpw.attr('disabled', 'disabled');
      rPassContainer.css('display', 'none');
      bookBtn.removeClass('disabled');
      signUpTitleContainer.css('display', 'none');

      if (this.userData.first_name) {
        fNameInput.val(this.userData.first_name);
      }

      if (this.userData.last_name) {
        lNameInput.val(this.userData.last_name);
      }

      emailInput.val(this.userData.email_address).attr('disabled', 'disabled');

      if (this.userData.mobile_phone) {
        if (phone_code_multiple_prefix) {
          var mobile_phone = this.userData.mobile_phone ? this.userData.mobile_phone.split('-') : [];

          phonePrefixInput.val('+' + mobile_phone[0]);
          phoneInput.val(mobile_phone[1]);
        } else {
          phoneInput.val(this.userData.mobile_phone);
        }
      }

      /*if (site.client.isMobile) {
        if (this.userData.mobile_email_optin || this.userData.pc_email_optin) {
          signUpEmailInput.attr('checked', 'checked');
        } else {
          signUpEmailInput.removeAttr('checked');
        }
      } else {
        if (this.userData.pc_email_optin) {
          signUpEmailInput.attr('checked', 'checked');
        } else {
          signUpEmailInput.removeAttr('checked');
        }
      }

      if (this.userData.sms_optin) {
        signUpSMSInput.attr('checked', 'checked');
      } else {
        signUpSMSInput.removeAttr('checked');
      }*/
    } else {
      this.signInContainer.css('display', 'block');
      // signUpPrivacyContainer.css('display', 'block');
      this.bookContainer.addClass('guest');
    }

    signUpPrivacyContainer.find('label a').on('tap click', function(e, data) {
      e.stopPropagation();
      e.preventDefault();
      window.open($(this).attr('href'), $(this).attr('target'));
      return false;
    });

    signUpEmailContainer.find('label a').on('tap click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      window.open($(this).attr('href'), $(this).attr('target'));
      return false;
    });

    signInLink.on('click', function(e) {
      e.preventDefault();
      var h;

      errorMessages.css('display', 'none');
      errorContainer.css('display', 'none');
      me.container.find('input, textarea, .label, .picker-handle').removeClass('error');
      signInLinkContainer.fadeOut(1000, function() {
        guestLinkContainer.fadeIn(1000);
      });
      // signUpPrivacyContainer.css('display', 'none');
      rpw.val('').attr('disabled', 'disabled');
      me.bookContainer.removeClass('guest');
      me.bookContainer.css('display', 'none');
      bookBtn.css('display', 'none');

      signIn.css('display', 'none');
      signIn.fadeIn(2000, function() {
        setSignIn();
      });
    });

    forgotPasswordLink.on('click', function(e) {
      e.preventDefault();

      // Reset the Error messages
      errorMessages.css('display', 'none');
      errorContainer.css('display', 'none');
      me.container.find('input, textarea, .label, .picker-handle').removeClass('error');

      email = loginEmail.val(); // Take the Signin Email field value.
      actionURL = forgotPasswordLink.attr('href');

      if (!hiddenForm || !actionURL) {
        return null;
      }
      if (!email) {
        errorContainer.css('display', 'block');
        loginEmail.addClass('error');
        errorMessages.filter('#error-signin-email').css('display', 'block');
        return null;
      }

      var hiddenEmailNode = hiddenForm.find('.js-hidden-email');
      hiddenEmailNode.val(email);

      var hiddenReturnNode = hiddenForm.find('.js-hidden-return'),
          returnURL = window.location.pathname;
      hiddenReturnNode.val(returnURL);

      hiddenForm.submit();
    });

    guestLink.on('click', function(e) {
      e.preventDefault();
      var h;

      errorMessages.css('display', 'none');
      errorContainer.css('display', 'none');
      me.container.find('input, textarea, .label, .picker-handle').removeClass('error');
      guestLinkContainer.fadeOut(1000, function() {
        signInLinkContainer.fadeIn(1000);
      });
      // signUpPrivacyContainer.css('display', 'block');
      rpw.val('').removeAttr('disabled');
      me.bookContainer.addClass('guest');
      bookBtn.css('display', 'block');

      signIn.fadeOut(1000, function() {
        me.bookContainer.fadeIn(1000, function() {
          setSignIn();
        });
      });
    });
    window.fbsignInBtn = fbsignInBtn;

    function setSignIn() {
      fbsignInBtn.click(function() {
        var token = null,
            $this = $(this),
            params = [],
            last_source = null,
            pc_email_promotions = 0,
            $optInFormInput = $('#form--facebook_signin--field--PC_EMAIL_PROMOTIONS');

        if ($this.hasClass('disabled')) {
          return;
        }

        last_source = 'appointment_booking';
        pc_email_promotions = $optInFormInput.is(':checked') ? 1 : 0;

        if (typeof FB === 'object') {
          FB.getLoginStatus(function(response) {
            statusChangeCallback(response);
          });
        }

        function statusChangeCallback(response) {
          if (FB.getAuthResponse()) {
            token = response.authResponse.accessToken;
            rpccall();
          }
        }

        function rpccall() {
          $this.addClass('disabled');
          params.push({
            _SUBMIT: 'facebook_signin',
            token: token,
            LAST_SOURCE: last_source,
            PC_EMAIL_PROMOTIONS: pc_email_promotions
          });

          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: JSON.stringify(params),
            onSuccess: function(jsonRpcResponse) {
              var h,
                  rData = jsonRpcResponse.getData().userinfo;

              me.model.updateAuthToken(function() {
                $this.removeClass('disabled');
                emailInput.val(rData.email_address).attr('disabled', 'disabled');
                if (rData.first_name) {
                  fNameInput.val(rData.first_name);
                }
                if (rData.last_name) {
                  lNameInput.val(rData.last_name);
                }
                if (rData.mobile_phone) {
                  phoneInput.val(rData.mobile_phone);
                }

                fNameInput.focus();
                lNameInput.focus();
                emailInput.focus();

                me.userData = rData;
              });

              errorContainer.hide();
              errorMessages.hide();
              pw.removeClass('error');
              loginEmail.removeClass('error');

              $this.removeClass('disabled');

              signInLink.show();
              bookBtn.removeClass('disabled');

              rpw.val('').attr('disabled', 'disabled');
              rPassContainer.hide();

              me.bookContainer.show();
              bookBtn.show();

              guestLinkText.addClass('hidden');

              h = signIn.css('height');
              signIn.animate({height: 0}, 1000, function() {
                signIn.hide();
                signIn.addClass('hidden');
                signIn.height(h);
                me.bookContainer.removeClass('guest');
                me.signInContainer.hide();
              });
            },
            onFailure: function(jsonRpcResponse) {
              var errObjs = jsonRpcResponse.getMessages();

              errorContainer.show();
              errorMessages.hide();
              pw.removeClass('error');
              me.bookContainer.addClass('guest');
              loginEmail.removeClass('error');

              for (var i = 0; i < errObjs.length; i += 1) {
                var myErr = errObjs[i];
                if (myErr && myErr.key) {
                  if (myErr.key === 'required.password.signin' ||
                      myErr.key === 'required.password.signin.app') {
                    pw.addClass('error');
                    errorMessages.filter('#error-signin-password').show();
                  }

                  if (myErr.key === 'invalid.password.signin' ||
                      myErr.key === 'invalid.password.signin.app') {
                    pw.addClass('error');
                    errorMessages.filter('#error-signin-invalid-password').show();
                  }

                  if (myErr.key === 'required_or.device_id.login_id.required_or.signin' ||
                      myErr.key === 'required_or.email_address.device_id.required_or.signin' ||
                    myErr.key === 'required_or.email_address.device_id.required_or.signin.app') {
                    loginEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').show();
                  }

                  if (myErr.key === 'required.email_address.signin' ||
                      myErr.key === 'required.email_address.signin.app') {
                    loginEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').show();
                  }

                  if (myErr.key === 'invalid.email_address.signin' ||
                      myErr.key === 'invalid.email_address.signin.app') {
                    loginEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').show();
                  }

                  if (myErr.key === 'no_account..signin' ||
                      myErr.key === 'no_account..signin.app') {
                    loginEmail.addClass('error');
                    pw.addClass('error');
                    errorMessages.filter('#error-signin-no-account').show();
                  }

                  if (myErr.key === 'account_lockout' ||
                      myErr.key === 'account_lockout.app') {
                    errorMessages.filter('#error-signin-account-lockout').show();
                  }

                  if (myErr.key === 'social_fb_no_email' ||
                      myErr.key === 'social_fb_no_email.app') {
                    errorMessages.filter('#error-others').show().text(myErr.text);
                  }

                  if (myErr.key === 'social_duplicate_account_links' ||
                      myErr.key === 'social_duplicate_account_links.app') {
                    errorMessages.filter('#error-others').show().text(myErr.text);
                  }

                  if (myErr.key === 'signin_error2' ||
                      myErr.key === 'signin_error2.app') {
                    errorMessages.filter('#error-others').show().text(myErr.text);
                  }
                }
              }
              $this.removeClass('disabled');
            }
          });
        }
      });
      signInBtn.click(function(e) {
        e.preventDefault();
        var $this = $(this),
            params = [];

        if ($this.hasClass('disabled')) {
          return;
        }

        $this.addClass('disabled');
        params.push({
          _SUBMIT: 'signin',
          EMAIL_ADDRESS: loginEmail.val(),
          PASSWORD: pw.val()
        });

        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: JSON.stringify(params),
          onSuccess: function(jsonRpcResponse) {
            var h,
                rData = jsonRpcResponse.getData().userinfo;

            // Update the nav bar signin area to show that we are now signed in
            $('.site-my-mac-v1 .first-name').html(rData.first_name);
            $('.site-my-mac-v1 .site-my-mac__contents .site-my-mac__contents-signin').hide();
            $('.site-my-mac-v1 .site-my-mac__contents .site-my-mac__contents-signed_in').show();
            $('.site-my-mac-v1 .site-my-mac__contents .site-my-mac__contents-title').hide();
            $('.site-my-mac-v1 .site-my-mac__contents .site-my-mac__contents-title__alt').show();

            me.model.updateAuthToken(function() {
              $this.removeClass('disabled');
              emailInput.val(rData.email_address).attr('disabled', 'disabled');

              if (rData.first_name) {
                fNameInput.val(rData.first_name);
              }
              if (rData.last_name) {
                lNameInput.val(rData.last_name);
              }
              if (rData.mobile_phone) {
                if (phone_code_multiple_prefix) {
                  var pref = '+' + rData.mobile_phone.split('-').shift();
                  phonePrefixInput.val(pref);
                  phoneInput.val(rData.mobile_phone.split('-').pop());
                } else {
                  phoneInput.val(rData.mobile_phone);
                }
              }

              /*if (site.client.isMobile) {
                if (rData.mobile_email_optin) {
                  signUpEmailInput.attr('checked', 'checked');
                } else {
                  signUpEmailInput.removeAttr('checked');
                }
              } else {
                if (rData.pc_email_optin) {
                  signUpEmailInput.attr('checked', 'checked');
                } else {
                  signUpEmailInput.removeAttr('checked');
                }
              }

              if (rData.sms_optin) {
                signUpSMSInput.attr('checked', 'checked');
              } else {
                signUpSMSInput.removeAttr('checked');
              }*/

              fNameInput.focus();

              me.userData = rData;
            });

            errorContainer.css('display', 'none');
            errorMessages.css('display', 'none');
            pw.removeClass('error');
            loginEmail.removeClass('error');

            $this.removeClass('disabled');

            signInLink.css('display', 'inline-block');
            bookBtn.removeClass('disabled');

            rpw.val('').attr('disabled', 'disabled');
            rPassContainer.css('display', 'none');

            me.bookContainer.css('display', 'block');
            bookBtn.css('display', 'inline-block');

            guestLinkText.addClass('hidden');

            if (hide_newsletter_checkbox) {
              signUpPrivacyContainer.addClass('hidden');
            }
            h = signIn.css('height');
            signIn.animate({height: 0}, 1000, function() {
              signIn.css('display', 'none');
              signIn.height(h);
              me.bookContainer.removeClass('guest');
              me.signInContainer.css('display', 'none');
            });
          },
          onFailure: function(jsonRpcResponse) {
            var errObjs = jsonRpcResponse.getMessages();

            errorContainer.css('display', 'block');
            errorMessages.css('display', 'none');
            pw.removeClass('error');
            me.bookContainer.addClass('guest');
            loginEmail.removeClass('error');

            for (var i = 0; i < errObjs.length; i += 1) {
              var myErr = errObjs[i];
              if (myErr && myErr.key) {
                if (myErr.key === 'required.password.signin' ||
                    myErr.key === 'required.password.signin.app') {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-password').css('display', 'block');
                }

                if (myErr.key === 'invalid.password.signin' ||
                    myErr.key === 'invalid.password.signin.app' ||
                    myErr.key === 'format.password.signin') {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-invalid-password').css('display', 'block');
                }

                if (myErr.key === 'required_or.email_address.device_id.required_or.signin' ||
                    myErr.key === 'required_or.email_address.device_id.required_or.signin.app') {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'required.email_address.signin' ||
                    myErr.key === 'required.email_address.signin.app') {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'invalid.email_address.signin' ||
                    myErr.key === 'invalid.email_address.signin.app') {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'no_account..signin' ||
                    myErr.key === 'no_account..signin.app') {
                  loginEmail.addClass('error');
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-no-account').css('display', 'block');
                }
                if (myErr.key === 'account_lockout' ||
                    myErr.key === 'account_lockout.app') {
                  errorMessages.filter('#error-signin-account-lockout').css('display', 'block');
                }
              }
            }

            $this.removeClass('disabled');
            generic.focusErrors($('.js-error-message'), $('.js-sign-in-form-container'));
          }
        });
      });
    }

    bookBtn.click(onSubmitBooking);

    function onSubmitBooking(e) {
      e.preventDefault();
      var params = {},
          signUpEmailParams = [],
          signUpEmailObj = {},
          isEmptyField = 0,
          signUpTitle,
          phone,
          phone1,
          phone2,
      oabSMSNotificationTermsAccepted,
      fName = fNameInput.val(),
      lName = lNameInput.val(),
      email = emailInput.val(),
      prefix = phonePrefixInput.val(),
      phone = phoneInput.val(),
      phone1 = phoneInput1.val(),
      phone2 = phoneInput2.val(),
      comment = commentsInput.val(),
      signUpTitle = signUpTitleInput.is(':checked') ? signUpTitleInput.val() : '',
      signUpEmail = signUpEmailInput.is(':checked') ? signUpEmailInput.val() : 0,
      signUpSMS = signUpSMSInput.is(':checked') ? signUpSMSInput.val() : 0,
      enableApptSMS = isSMSNotificationsEnabled,
      requireTermsForSMS = smsNotificationTerms.length ? 1 : 0,
      signUpPrivacy = (me.userData.signed_in && hide_newsletter_checkbox) || signUpPrivacyInput.is(':checked') ? signUpPrivacyInput.val() : '',
      signUpEmailDone = false,
      signUpSMSDone = false,
      $this = $(this),
      isArray = me.serviceIds instanceof Array;

      if ($this.hasClass('disabled')) {
        return;
      }

      errorContainer.css('display', 'block');
      $('html, body').animate({
        scrollTop: $('body').offset().top
      }, 800);
      errorMessages.css('display', 'none');
      me.container.find('input, textarea, .label, .picker-handle').removeClass('error');
      emptyInputs();
      if (isEmptyField) {
        generic.focusErrors($('.js-error-message'), $('.js-book-appt guest, .js-book-appt'));
        $this.removeClass('disabled');
        return;
      }

      $this.addClass('disabled');

      site.track.evtLink({
        event_name: 'appointmentBooking_bookNow',
        event_category: 'appointment booking',
        event_action: 'bookNow',
        event_label: me.counterData.store_no + ' - ' + me.counterData.name + ' - ' + me.startTime
      });

      params = {
        _TOKEN: '',
        counter_id: me.counterId,
        calendar_id: me.calendarId,
        appointment_service_id: me.serviceIds,
        start_time: me.startTime,
        customer_first_name: fName,
        customer_last_name: lName,
        customer_email: email,
        customer_title: signUpTitle,
        myNonSubsequentDuration: me.myNonSubsequentDuration,
        nonSubsequentServicesSelf: me.nonSubsequentServicesSelf,
        subsequentServicesSelf: me.subsequentServicesSelf
      };

      if (phone) {
        // Making sure we pass phone number stripped from any dashes, pluses and brackets.
        params.customer_phone = phone.replace(/\(|\)|-|\+/giu, '');
        // Remove leading zeros from phone num.
        params.customer_phone = params.customer_phone.replace(/^(0+)(\d+)$/giu, '$2');

        if (appointment_booking_show_mobile_prefix) {
          // Remove any dashes, pluses, brackets or '(0)' from prefix.
          prefix = prefix.replace(/\(0\)|\(|\)|-|\+/giu, '');

          if (phoneInput.length === 2) {
            params.customer_phone = prefix + '-' + phone1 + '-' + phone2;
          } else {
            params.customer_phone = prefix + params.customer_phone;
          }
        } else {
          params.customer_phone = countryCode + params.customer_phone;
        }

        // Remove leading zeros from formatted phone num (prefix/countryCode + phone num).
        params.customer_phone = params.customer_phone.replace(/^(0+)(\d+)$/giu, '$2');
      }

      if (requireTermsForSMS) {
        if (smsNotificationTerms.attr('type') === 'checkbox') {
          oabSMSNotificationTermsAccepted = smsNotificationTerms.is(':checked') ? 1 : 0;
        } else {
          oabSMSNotificationTermsAccepted = smsNotificationTerms.is(':checked') ? smsNotificationTerms.filter(':checked').val() : 0;
        }
      }

      if (enableApptSMS) {
        if (requireTermsForSMS) {
          if (oabSMSNotificationTermsAccepted) {
            params.sms_notifications_enabled = oabSMSNotificationTermsAccepted;
          }
        } else {
          params.sms_notifications_enabled = enableApptSMS;
        }
      }

      if (comment) {
        params.customer_comments = comment;
      }

      var oabSMSOptinValue = $('input[name="APPT_SMS_NOTIFICATIONS"]:checked').val();
      if (parseInt(oabSMSOptinValue)) {
        params.sms_notifications_enabled = 1;
      }

      function emptyInputs() {
        var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
        var phone_maxlength = phoneInput.attr('maxlength');
        var phone_regex = new RegExp(phoneInput.attr('pattern'));

        if (oab.appointment_booking_show_titles && signUpTitle === '' && me.userData.signed_in === 0) {
          errorMessages.filter('#error-signin-title').css('display', 'block');
          signUpTitleContainer.find('span.label, .picker-label').addClass('error');
          signUpTitleInput.addClass('error');
          isEmptyField = 1;
        }
        if (!fNameInput.val()) {
          errorMessages.filter('#error-book-first-name').css('display', 'block');
          fNameInput.addClass('error');
          isEmptyField = 1;
        }
        if (!lNameInput.val() && !lNameOptional) {
          errorMessages.filter('#error-book-last-name').css('display', 'block');
          lNameInput.addClass('error');
          isEmptyField = 1;
        }
        if (!emailInput.val() || !testEmail.test(emailInput.val())) {
          errorMessages.filter('#error-book-email').css('display', 'block');
          emailInput.addClass('error');
          isEmptyField = 1;
        }
        if (signUpPrivacy === '' && !koreaLegal) {
          errorMessages.filter('#error-signup-privacy-invalid').css('display', 'block');
          signUpPrivacyContainer.find('span.label, .picker-handle').addClass('error');
          signUpPrivacyInput.addClass('error');
          isEmptyField = 1;
        }
        if (OAB_register_password_mandatory && !rpw.attr('disabled')) {
          var error_id = !rpw.val()
            ? '#error-register-password' : rpw.val().length < 6
              ? '#error-register-min-max-password' : '';
          if (error_id) {
            errorMessages.filter(error_id).css('display', 'block');
            passwordInput.addClass('error');
            isEmptyField = 1;
          }
        }
        if (phoneInput.length === 2) {
          var phone1_regex = new RegExp(phoneInput1.attr('pattern')),
              phone2_regex = new RegExp(phoneInput2.attr('pattern'));
          if (!phoneInput1.val() || !phone1_regex.test(phone1)) {
            errorMessages.filter('#error-book-mobile_part1_invalid').css('display', 'block');
            phoneInput1.addClass('error');
            isEmptyField = 1;
          }
          if (!phoneInput2.val() || !phone2_regex.test(phone2)) {
            errorMessages.filter('#error-book-mobile_part2_invalid').css('display', 'block');
            phoneInput2.addClass('error');
            isEmptyField = 1;
          }
        } else if (!phoneInput.val() && errorMessages.filter('#error-signup-sms').is(':hidden')) {
          errorMessages.filter('#error-book-phone').css('display', 'block');
          phoneInput.addClass('error');
          isEmptyField = 1;
        } else if (!phone_regex.test(phone)) {
          phoneInput.addClass('error');
          errorContainer.css('display', 'block');
          errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
          isEmptyField = 1;
        }
        if (oab.appt_email_promotions_mandatory && signUpEmailInput.val() && !signUpEmailInput.is(':checked')) {
          errorMessages.filter('#error-oab-email-promotions').css('display', 'block');
          emailPromotionsLabel.find('span.label').addClass('error');
          signUpEmailInput.addClass('error');
          isEmptyField = 1;
        }
        if (koreaLegal) {
          if (!acceptedPrivacyPolicy.is(':checked') || acceptedPrivacyPolicy.filter(':checked').val() === '0') {
            errorMessages.filter('#error-terms-conditions').css('display', 'block');
            acceptTermsHead.addClass('error');
            isEmptyField = 1;
          } else {
            acceptTermsHead.removeClass('error');
          }
          if (!oabSMSOptin.is(':checked')) {
            errorMessages.filter('#error-oab-sms').css('display', 'block');
            acceptoabSMSHead.addClass('error');
            isEmptyField = 1;
          } else {
            acceptoabSMSHead.removeClass('error');
          }
          if (!pcEmailPromotions.is(':checked')) {
            errorMessages.filter('#error-marketing-channels').css('display', 'block');
            acceptEmailHead.addClass('error');
            isEmptyField = 1;
          } else {
            acceptEmailHead.removeClass('error');
          }
          if (!smsPromotions.is(':checked')) {
            errorMessages.filter('#error-marketing-channels').css('display', 'block');
            acceptSMSHead.addClass('error');
            isEmptyField = 1;
          } else {
            acceptSMSHead.removeClass('error');
          }
          if (!postalPromotions.is(':checked')) {
            errorMessages.filter('#error-marketing-channels').css('display', 'block');
            acceptPostalHead.addClass('error');
            isEmptyField = 1;
          } else {
            acceptPostalHead.removeClass('error');
          }
          if (!pcEmailPromotions.is(':checked') || !smsPromotions.is(':checked') || !postalPromotions.is(':checked')) {
            acceptPrivacyHead.addClass('error');
            errorMessages.filter('#error-marketing-channels').css('display', 'block');
          } else {
            acceptPrivacyHead.removeClass('error');
          }
          if (!acceptedThirdParty.is(':checked')) {
            errorMessages.filter('#error-accepeted-third-party').css('display', 'block');
            acceptThirdPartyHead.addClass('error');
            isEmptyField = 1;
          } else {
            acceptThirdPartyHead.removeClass('error');
          }
        }
      }

      function onBookSuccess(r) {
        var updateData,
            apptId = r.id;

        site.track.evtView({
            page_url: '/book-appointment/complete',
            location: location.origin + '/book-appointment/complete',
            page_name:'Book Appointment - Complete'
        });

        site.track.evtLink({
          event_name: 'appointmentBooking_complete',
          event_category: 'appointment booking',
          event_action: 'appointment booked',
          event_label: r.counter.store_no  + ' - ' + r.counter.name  + ' - ' + r.start_time
        });

        // We need to pass some additional data down since the last appointment booked does not have all the data we need
        // to display on the confirmation page
        r.friendServiceData = this.friendServiceData;
        r.selfServiceData = this.selfServiceData;
        r.firstStartTime = this.firstStartTime;

        updateData = {
          sectionId: 'next',
          params: r
        };
        me.model.update(updateData);
        //$this.addClass('disabled');
        errorMessages.css('display', 'none');
        errorContainer.css('display', 'none');
        me.container.find('input, textarea, .label, .picker-handle').removeClass('error');
      }

      function onBookError(r) {
        $this.removeClass('disabled');

        var errFName = r.customer_first_name,
            errLName = r.customer_last_name,
            errEmail = r.customer_email,
            errPhone = r.customer_phone;

        errorContainer.css('display', 'block');
        errorMessages.css('display', 'none');
        var errorShown = false;

        if (errFName && errFName.length) {
          errorMessages.filter('#error-book-first-name').css('display', 'block');
          fNameInput.addClass('error');
          errorShown = true;
        }
        if (errLName && errLName.length) {
          errorMessages.filter('#error-book-last-name').css('display', 'block');
          lNameInput.addClass('error');
          errorShown = true;
        }
        if (errEmail && errEmail.length) {
          errorMessages.filter('#error-book-email').css('display', 'block');
          emailInput.addClass('error');
          errorShown = true;
        }
        if (errPhone && errPhone.length) {
          errorMessages.filter('#error-book-phone').css('display', 'block');
          phoneInput.addClass('error');
          errorShown = true;
        }

        // Unhandled error should still show the user something
        if (!errorShown) {
          me.launchBookConflictOverlay();
        }
      }

      function doBooking() {
        errorMessages.css('display', 'none');
        me.container.find('input, textarea, .label, .picker-handle').removeClass('error');

        if (isEmptyField) {
          $this.removeClass('disabled');
        } else if (me.updateMode && me.appointmentId) {
          me.model.changeAppointment(me.appointmentId, params, onBookSuccess, onBookError);
        } else {
          // Booking can need to create up to 4 appointments for Subsequent + SBS (Mac only supports Subsequent currently, but 
          // there is no reason not to keep the framework in case they decide to add SBS later)
          // When there is more than one appointment, one will be a top level parent and the others will all be children
          // of that (or children of children). Here we build an array of appointments to pass to bookAppointments()
          var appointmentsArray = [];
          var apptIdIndex = 0, nonSubSelfId = null, subSelfId = null, nonSubFriendId = null;
          function addToTime(timeStr, minutesToAdd) {
            hours = parseInt(timeStr.substr(-8, 2));
            minutes = parseInt(timeStr.substr(-5, 2));
            minutes += minutesToAdd;
            while (minutes > 59) {
              minutes -= 60;
              hours += 1;
            }
            hours = hours.toString(); minutes = minutes.toString();
            if (hours.length == 1) hours = '0' + hours;
            if (minutes.length == 1) minutes = '0' + minutes;

            return timeStr.substr(0, timeStr.length - 8) + hours + ':' + minutes + ':00';
          }

          // If we have a nonsubsequent appointment for ourself, that will be the top level appointment
          if (params.nonSubsequentServicesSelf.length > 0) {
            appointmentsArray.push({
              temp_id: apptIdIndex,
              temp_parent_id: null,
              counter_id: params.counter_id,
              services: params.nonSubsequentServicesSelf,
              customer_email: params.customer_email,
              customer_phone: params.customer_phone,
              customer_first_name: params.customer_first_name,
              customer_last_name: params.customer_last_name,
              customer_comments: params.customer_comments,
              sms_notifications_enabled: params.sms_notifications_enabled,
              start_time: params.start_time,
              subsequent: false,
              booked_for_friend: false,
              calendar_id: params.calendar_id,
            });
            nonSubSelfId = apptIdIndex;
            apptIdIndex += 1;
          }
          if (params.subsequentServicesSelf.length > 0) {
            appointmentsArray.push({
              temp_id: apptIdIndex,
              temp_parent_id: nonSubSelfId,
              counter_id: params.counter_id,
              services: params.subsequentServicesSelf,
              customer_email: params.customer_email,
              customer_phone: params.customer_phone,
              customer_first_name: params.customer_first_name,
              customer_last_name: params.customer_last_name,
              customer_comments: params.customer_comments,
              sms_notifications_enabled: params.sms_notifications_enabled,
              start_time: addToTime(params.start_time, params.myNonSubsequentDuration),
              subsequent: true,
              booked_for_friend: false,
            });
            subSelfId = apptIdIndex;
            apptIdIndex += 1;
          }
          // No friend appointments on Mac, as of yet
          /* if (params.nonSubsequentServicesFriend.length > 0) {
            appointmentsArray.push({
              temp_id: apptIdIndex,
              temp_parent_id: ((nonSubSelfId != null) ? nonSubSelfId : subSelfId),
              counter_id: params.counter_id,
              services: params.nonSubsequentServicesFriend,
              customer_email: params.customer_email,
              customer_phone: params.customer_phone,
              customer_first_name: params.customer_first_name,
              customer_last_name: params.customer_last_name,
              friend_first_name: params.friend_first_name,
              friend_last_name: params.friend_last_name,
              start_time: params.start_time,
              subsequent: false,
              booked_for_friend: true,
            });
            nonSubFriendId = apptIdIndex;
            apptIdIndex += 1;
          }
          if (params.subsequentServicesFriend.length > 0) {
            appointmentsArray.push({
              temp_id: apptIdIndex,
              temp_parent_id: ((nonSubFriendId != null) ? nonSubFriendId : ((nonSubSelfId != null) ? nonSubSelfId : subSelfId)),
              counter_id: params.counter_id,
              services: params.subsequentServicesFriend,
              customer_email: params.customer_email,
              customer_phone: params.customer_phone,
              customer_first_name: params.customer_first_name,
              customer_last_name: params.customer_last_name,
              friend_first_name: params.friend_first_name,
              friend_last_name: params.friend_last_name,
              subsequent: true,
              booked_for_friend: true,
              start_time: addToTime(params.start_time, params.friendNonSubsequentDuration),
            });
          } */ // End of currently not-enabled friend appointment code
          me.model.bookAppointments(appointmentsArray, onBookSuccess, onBookError);
        }
      }

      signUpEmailObj._SUBMIT = 'email_signup';
      signUpEmailObj.EMAIL_ADDRESS = email;
      signUpEmailObj.PC_EMAIL_ADDRESS = email;
      signUpEmailObj.FIRST_NAME = fNameInput.val();
      signUpEmailObj.LAST_NAME = lNameInput.val();
      if (signUpEmail) {
        signUpEmailObj.PC_EMAIL_PROMOTIONS = 1;
      }

      if (!rpw.attr('disabled') && rpw.val() != '') {
        signUpEmailObj._SUBMIT = 'registration_short';
        signUpEmailObj.PASSWORD = rpw.val();
        signUpEmailObj.PASSWORD2 = rpw.val();
        signUpEmailObj.PC_EMAIL_ADDRESS2 = email;
        signUpEmailObj.ACCEPTED_PRIVACY_POLICY = signUpPrivacy;//1;
        signUpEmailObj.CAN_ADD_ADDRESS = 0;
        if (signUpEmail) {
          signUpEmailObj.PC_EMAIL_PROMOTIONS = 1;
        }
        if (signUpTitleInput) {
          signUpEmailObj.TITLE = signUpTitle;
        }
      }

      if (rpw.attr('disabled') || rpw.val() == '') {
        if (!signUpEmail) {
          signUpEmailObj.ACTION = 'unset';
        }
      }
      if (koreaLegal) {
        var smsPromotionsValue = $('input[name="SMS_PROMOTIONS"]:checked').val(),
            pcEmailPromotionsValue = $('input[name="PC_EMAIL_PROMOTIONS"]:checked').val(),
            postalPromotionsValue = $('input[name="POSTAL_PROMOTIONS"]:checked').val(),
            acceptedThirdPartyValue = $('input[name="ACCEPTED_THIRD_PARTY"]:checked').val();
        signUpEmailObj.MOBILE_NUMBER = phonePrefixInput.val() + '-' + phone1 + '-' + phone2;
        signUpEmailObj.SMS_PROMOTIONS = smsPromotionsValue;
        signUpEmailObj.PC_EMAIL_PROMOTIONS = pcEmailPromotionsValue;
        signUpEmailObj.POSTAL_PROMOTIONS = postalPromotionsValue;
        signUpEmailObj.ACCEPTED_THIRD_PARTY = acceptedThirdPartyValue;
      }

      if (phone_code_multiple_prefix) {
        if (phonePrefixInput.val()) {
          phone = phonePrefixInput.val().replace(/^\+/, '') + '-' + phone;
        }
      }

      if (signUpSMS && (!me.userData || !me.userData.sms_optin)) {
        signUpEmailObj._SECONDARY_SUBMIT = 'sms';
        signUpEmailObj.MOBILE_PHONE = phone;
        signUpEmailObj.MOBILE_NUMBER = phone;
        signUpEmailObj.SMS_PROMOTIONS = 1;
      }

      if (!signUpSMS && !ommit_sms) {
        signUpEmailObj._SECONDARY_SUBMIT = 'sms';
        signUpEmailObj.PHONE2 = phone;
        signUpEmailObj.SMS_PROMOTIONS = 0;
      }

      if ($.cookie('csrftoken')) {
        signUpEmailObj._TOKEN = $.cookie('csrftoken');
      }

      signUpEmailObj.LAST_SOURCE = "appointment_booking";

      signUpEmailParams.push(signUpEmailObj);

      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: JSON.stringify(signUpEmailParams),
        onSuccess: function(jsonRpcResponse) {
          if (!rpw.attr('disabled') && rpw.val() != '') {
            // Once you are signed in under your user, the csrftoken cookie gets updated. We must use that or else the next rpc will 
            // fail with "CSRF Token Invalid"
            if ($.cookie('csrftoken')) {
              signUpEmailObj._TOKEN = $.cookie('csrftoken');
            }
            signUpEmailObj._SUBMIT = 'registration';
            signUpEmailParams = [];
            signUpEmailParams.push(signUpEmailObj);

            // Update the nav bar signin area to show that we are now signed in
            $('.site-my-mac-v1 .first-name').html(signUpEmailParams[0].FIRST_NAME);
            $('.site-my-mac-v1 .site-my-mac__contents .site-my-mac__contents-signin').hide();
            $('.site-my-mac-v1 .site-my-mac__contents .site-my-mac__contents-signed_in').show();
            $('.site-my-mac-v1 .site-my-mac__contents .site-my-mac__contents-title').hide();
            $('.site-my-mac-v1 .site-my-mac__contents .site-my-mac__contents-title__alt').show();

            generic.jsonrpc.fetch({
              method: 'rpc.form',
              params: JSON.stringify(signUpEmailParams),
              onSuccess: function(jsonRpcResponse) {
                signUpEmailDone = true;
                doBooking();
              },
              onFailure: function(jsonRpcResponse) {
                doBooking();
              }
            });
          } else {
            signUpEmailDone = true;
            doBooking();
          }
        },
        onFailure: function(jsonRpcResponse) {
          var errObjs = jsonRpcResponse.getMessages();
          var errorMessagePasswordId = '';

          errorContainer.css('display', 'block');
          errorMessages.css('display', 'none');
          me.container.find('input, textarea, .label, .picker-handle').removeClass('error');

          for (var i = 0; i < errObjs.length; i += 1) {
            var myErr = errObjs[i];
            if (myErr && myErr.key) {
              if (myErr.key === 'required.pc_email_address.email_signup' ||
                  myErr.key === 'invalid.pc_email_address.email_signup' ||
                  myErr.key === 'required.pc_email_address.email_signup.app' ||
                  myErr.key === 'invalid.pc_email_address.email_signup.app') {
                emailInput.addClass('error');
                errorMessages.filter('#error-signup-email').css('display', 'block');
              }

              if (myErr.key === 'required_dependency.sms_promotions.mobile_phone.dependency.sms' ||
                  myErr.key === 'required_dependency.sms_promotions.mobile_phone.dependency.sms.app') {
                phoneInput.addClass('error');
                errorMessages.filter('#error-signup-sms').css('display', 'block');
              }

              if (myErr.key === 'invalid.mobile_phone.sms' ||
                  myErr.key === 'invalid.mobile_phone.sms.app' || myErr.key === 'invalid.mobile_number.sms') {
                phoneInput.addClass('error');
                errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
              }

              if ((myErr.key === 'required.password.registration_short' ||
                  myErr.key === 'required.password.registration_short.app') &&
                 (errorMessagePasswordId !== 'error-register-min-max-password')) {
                rpw.addClass('error');
                errorMessagePasswordId = 'error-register-password';
                errorMessages.filter('#error-register-password').css('display', 'block');
                errorMessages.filter('#error-register-min-max-password').css('display', 'none');
              }

              if ((myErr.key === 'invalid.password.registration_short' ||
                  myErr.key === 'invalid.password.registration_short.app') &&
                 (errorMessagePasswordId !== 'error-register-min-max-password')) {
                rpw.addClass('error');
                errorMessagePasswordId = 'error-register-invalid-password';
                errorMessages.filter('#error-register-invalid-password').css('display', 'block');
                errorMessages.filter('#error-register-password').css('display', 'none');
                errorMessages.filter('#error-register-min-max-password').css('display', 'none');
              }

              if (myErr.key === 'min_max.password.registration_short' ||
                  myErr.key === 'min_max.password.registration_short.app' ||
                  myErr.key === 'format.password.registration_short') {
                rpw.addClass('error');
                errorMessagePasswordId = 'error-register-min-max-password';
                errorMessages.filter('#error-register-min-max-password').css('display', 'block');
                errorMessages.filter('#error-register-invalid-password').css('display', 'none');
                errorMessages.filter('#error-register-password').css('display', 'none');
              }

              if (myErr.key === 'required.pc_email_address.registration_short' ||
                  myErr.key === 'invalid.pc_email_address.registration_short' ||
                  myErr.key === 'required.pc_email_address.registration_short.app' ||
                  myErr.key === 'invalid.pc_email_address.registration_short.app') {
                emailInput.addClass('error');
                errorMessages.filter('#error-book-email').css('display', 'block');
              }

              if (myErr.key === 'required.accepted_privacy_policy.registration_short' ||
                  myErr.key === 'invalid.accepted_privacy_policy.registration_short' ||
                  myErr.key === 'required.accepted_privacy_policy.registration_short.app' ||
                  myErr.key === 'invalid.accepted_privacy_policy.registration_short.app' ||
                  signUpPrivacy === '') {
                signUpPrivacyInput.addClass('error');
                signUpPrivacyContainer.find('span.label, .picker-handle').addClass('error');
                errorMessages.filter('#error-signup-privacy-invalid').css('display', 'block');
              }

              if (myErr.key === 'invalid.accepted_privacy_policy.registration_short' ||
                  myErr.key === 'invalid.accepted_privacy_policy.registration_short.app') {
                emailInput.addClass('error');
                errorMessages.filter('#error-book-email').css('display', 'block');
                errorMessages.filter('#error-register-password').css('display', 'block');
              }

              if (myErr.key === 'required_dependency.mobile_number.sms_promotions.dependency.sms') {
                signUpSMSInput.addClass('error');
                signUpSMSContainer.find('span.label, .picker-handle').addClass('error');
                errorMessages.filter('#error-signup-sms').css('display', 'block');
              }

              if (myErr.key === 'account_exists' ||
                  myErr.key === 'account_exists.app') {
                emailInput.addClass('error');
                errorMessages.filter('#error-register-account-exist').css('display', 'block');
              }
            }
          }

          $this.removeClass('disabled');
        }
      });
    }
  };

  apptBook.confirmAccount.prototype.launchBookConflictOverlay = function() {
    var errKey = 'book_conflict';
    apptBook.showErrorDialog(errKey);
  };

  Drupal.behaviors.apptBookconfirmAccount = {
    attach: function(context) {
      var view = new apptBook.confirmAccount($('#confirm'));
      view.setModel(apptBook.sectionModel).startObserving();
    }
  };

  if (Drupal.settings.globals_variables.gdpr_compliant) {
    $('.info-link').live('click', function(e) {
      e.preventDefault();
      var infoLink = $(e.currentTarget);

      function remInfoMessageBox() {
        if ($('#info-message-box').get(0)) {
          $('#info-message-box').remove();
        }
        if ($('#infoArrowBefore').get(0)) {
          $('#infoArrowBefore').remove();
        }
      }

      remInfoMessageBox();

      $("<div id='info-message-box'><div id='info-text'></div></div>").appendTo('body');
      var infoBoxId = $('#' + infoLink.attr('message-in'));
      var infoMessageBox = $('#info-message-box');

      $('#info-text').html("<div id='info-close'>X</div>" + infoBoxId.html());

      $('#cboxClose, #info-close').live('mousedown', function() {
        remInfoMessageBox();
      });

      function setInfoBoxPosition() {
        var infoLinkTop = infoLink.offset().top + infoLink.height() + 10;
        var infoLinkLeft = infoLink.offset().left;

        if (screen.width <= 640) {
          infoLinkLeft = 10;
          $('head').append("<style id='infoArrowBefore'   type='text/css'>#info-message-box:before{left:" + (infoLink.offset().left - 10) + 'px;}</style>');
        } else if ((infoMessageBox.outerWidth(true) === 500) && ((infoLinkLeft + 500) > screen.width)) {
          infoLinkLeft = infoLinkLeft - 480;
          infoMessageBox.addClass('top-right-arrow');
        }
        infoMessageBox.css({
          top: infoLinkTop,
          left: infoLinkLeft
        });
      }
      setInfoBoxPosition();
      $(window).resize(function() {
        setInfoBoxPosition();
      });
    });
    $('#info-text span').live('mousedown', function() {
      window.location = $(this).attr('data-url');
    });
  }
})(jQuery);
